export const includes = <T extends U, U>(collection: ReadonlyArray<T>, searchElement: U): searchElement is T =>
    collection.includes(searchElement as T);
